import { Tag, Tooltip, Typography } from "antd";
import { useT } from "../i18n/context";
import type { AdapterType, AgentMeta, ProviderInfo, SessionMeta, TodoItem } from "../types";

const { Text } = Typography;

interface ChatHeaderProps {
  agent: AgentMeta;
  session: SessionMeta | undefined;
  providers: ProviderInfo[];
  showModelSwitcher: boolean;
  onModelSwitcherClick: () => void;
  todos: TodoItem[];
  showTodoPanel: boolean;
  onTodoTagClick: () => void;
}

export default function ChatHeader({
  agent,
  session,
  providers,
  showModelSwitcher,
  onModelSwitcherClick,
  todos,
  showTodoPanel,
  onTodoTagClick,
}: ChatHeaderProps) {
  const t = useT();

  const adapterType: AdapterType = session?.sessionAdapterType ?? agent.adapterType;
  const providerId = session?.sessionProviderId ?? "";
  const providerName = providers.find((p) => p.id === providerId)?.name ?? providerId;
  const model = session?.sessionModel ?? "";
  const isSessionLevel = !!session?.sessionModel;

  const doneTodos = todos.filter((td) => td.status === "completed").length;

  return (
    <div
      style={{
        padding: "12px 20px",
        borderBottom: "1px solid var(--lude-im-border)",
        display: "flex",
        alignItems: "center",
        gap: 8,
      }}
    >
      {agent.avatarUrl ? (
        <img src={agent.avatarUrl} alt="" style={{ width: 24, height: 24, borderRadius: "50%" }} />
      ) : (
        <span>{agent.adapterType === "ClaudeCode" ? "🟠" : "🟢"}</span>
      )}
      <Text strong style={{ color: "var(--lude-im-text-primary)" }}>{agent.name}</Text>

      {showModelSwitcher && (
        <Tooltip title={t("model.tooltip")}>
          <button
            onClick={onModelSwitcherClick}
            style={{
              background: "none",
              border: "1px solid var(--lude-im-border)",
              cursor: "pointer",
              padding: "2px 8px",
              borderRadius: "var(--lude-im-radius-sm)",
              display: "flex",
              alignItems: "center",
              gap: 4,
            }}
          >
            <Text type="secondary" style={{ fontSize: 11, color: "var(--lude-im-text-secondary)" }}>
              {adapterType}
            </Text>
            <Text type="secondary" style={{ fontSize: 11, color: "var(--lude-im-text-secondary)" }}>
              /
            </Text>
            <Text type="secondary" style={{ fontSize: 11, color: "var(--lude-im-text-secondary)" }}>
              {providerName}
            </Text>
            <Text type="secondary" style={{ fontSize: 11, color: "var(--lude-im-text-secondary)" }}>
              /
            </Text>
            <Text
              type="secondary"
              style={{
                fontSize: 11,
                fontWeight: isSessionLevel ? 600 : 400,
                color: "var(--lude-im-text-secondary)",
              }}
            >
              {model}
            </Text>
          </button>
        </Tooltip>
      )}

      <div style={{ flex: 1 }} />

      {todos.length > 0 && (
        <Tooltip title={t("todo.tooltip")}>
          <Tag
            color="blue"
            style={{
              cursor: "pointer",
              margin: 0,
              fontSize: 12,
              opacity: showTodoPanel ? 0.6 : 1,
            }}
            onClick={onTodoTagClick}
          >
            {t("todo.tag", { done: doneTodos, total: todos.length })}
          </Tag>
        </Tooltip>
      )}
    </div>
  );
}
